import { render, staticRenderFns } from "./IntegrationsCustomFields.vue?vue&type=template&id=966f7038&"
import script from "./IntegrationsCustomFields.vue?vue&type=script&lang=js&"
export * from "./IntegrationsCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports